import { createSelector } from 'reselect'
import {
  getOrEmptyObject,
  createIsRequestingSelector,
  createErrorSelector,
  createSelectorOrNull
} from '../../utils/selectors'

import { REDUCER_KEY } from './reducer'
import api from './api'

const not = value => !value

export const selectLoginState = getOrEmptyObject(REDUCER_KEY)

export const isLoginRequessting = createIsRequestingSelector(selectLoginState)()
export const selectLoginError = createErrorSelector(selectLoginState)()

export const selectLoginToken = createSelectorOrNull(selectLoginState)('token')
export const selectLoginTokenData = createSelector(
  selectLoginToken,
  api.decodeToken
)

export const isTokenExpired = createSelector(
  selectLoginToken,
  api.isTokenExpired
)

export const isLoggedIn = createSelector(
  isTokenExpired,
  not
)
